<template>
    <div class="ss-live-page">
        <banner-video :vm="ssLiveBanner"></banner-video>
        <teacherTeam :vm="teacherInfo"></teacherTeam>
        <img-box :vm="supportLiveList"></img-box>
        <compare :vm="ssLiveCompare"></compare>
        <self-equipment></self-equipment>
        <colund-learn></colund-learn>
        <subject-intro></subject-intro>
        <img-box :vm="liveOperateList" :isNotAuto="true"></img-box>
    </div>
</template>
<script>
import bannerVideo from './components/banner-video'
import teacherTeam from './components/teacher-team'
import compare from './components/compare'
import selfEquipment from './components/self-equipment'
import colundLearn from './components/ss/clound-learn'
import subjectIntro from './components/subject-intro'
import imgBox from './components/img-box.vue'
import { ssLiveBanner, ssLiveTeacherTeam, ssLiveCompare, supportLiveList,  liveOperateList } from '@/const'
export default {
    data () {
        return {
            ssLiveBanner: ssLiveBanner,
            teacherInfo: ssLiveTeacherTeam,
            ssLiveCompare: ssLiveCompare,
            supportLiveList: supportLiveList,
            liveOperateList: liveOperateList
        }
    },
    components: { bannerVideo, teacherTeam, compare, selfEquipment, colundLearn, subjectIntro, imgBox }
}
</script>
